import { FileText, ExternalLink } from "lucide-react";

const OFFICIAL_URL = "https://www.minedu.gov.gr/panelladikes-eksetaseis-pistopoiitika";

export default function ExamPapers() {
  return (
    <section id="exams" data-testid="exams-section" className="py-20 md:py-32 bg-secondary/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="bg-primary text-primary-foreground rounded-sm overflow-hidden">
          <div className="p-8 sm:p-12 lg:p-16">
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-white/60 mb-4">// Εκπαιδευτικό Υλικό</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight flex items-start gap-3">
              <FileText className="h-8 w-8 shrink-0 mt-1" strokeWidth={1.5} />
              Θέματα Πανελληνίων Εξετάσεων
            </h2>
            <p className="mt-5 text-white/80 leading-relaxed max-w-2xl">
              Θέματα & ενδεικτικές απαντήσεις προηγούμενων ετών, ανά μάθημα. Εξασκηθείτε με πραγματικά
              θέματα και προετοιμαστείτε με σιγουριά για τις εξετάσεις.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a
                href={OFFICIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="exams-cta"
                className="inline-flex items-center justify-center gap-2 bg-white text-primary font-mono-accent text-sm uppercase tracking-widest px-8 py-4 rounded-sm hover:bg-accent hover:text-white transition-colors"
              >
                Υπουργείο Παιδείας
                <ExternalLink className="h-4 w-4" />
              </a>
              <a
                href="https://www.oefe.gr/el/static/panelladikes.aspx"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="exams-cta-oefe"
                className="inline-flex items-center justify-center gap-2 border border-white/40 text-white font-mono-accent text-sm uppercase tracking-widest px-8 py-4 rounded-sm hover:bg-white hover:text-primary transition-colors"
              >
                Ο.Ε.Φ.Ε.
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
